// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"120":"d791898d6a5e9a36","8406":"2a833eb0ef00f8ef"}[chunkId] + ".js";
};